import { computed, Injectable, Signal, signal } from '@angular/core';
import { getCompanyList } from '@graphql/company';
import { CognitoService, UserWithID } from '@services/cognito/cognito.service';
import { Apollo } from 'apollo-angular';
import { GetCompanyListQuery } from 'gql/graphql';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  user: Signal<UserWithID | null>;
  companies = signal<GetCompanyListQuery['getCompanyList']>([]);
  currentCompany = computed(
    () =>
      this.companies().find((c) => c.licenseId === this.user()?.licenseId)
        ?.name ?? ''
  );

  constructor(
    readonly apollo: Apollo,
    private readonly cognitoService: CognitoService
  ) {
    this.user = this.cognitoService.loggedUser;
    apollo
      .watchQuery<GetCompanyListQuery>({
        query: getCompanyList,
      })
      .valueChanges.subscribe({
        next: ({ data }) => {
          this.companies.set(data.getCompanyList);
        },
        error: (err) => {
          //let errMsg = getErrorMessage(err, this.translate);
          //this.toast.notifyError(errMsg);
        },
      });
  }
}
